import { render, staticRenderFns } from "./DebrisGathererEditor.vue?vue&type=template&id=1cee01b6&scoped=true&"
import script from "./DebrisGathererEditor.vue?vue&type=script&lang=js&"
export * from "./DebrisGathererEditor.vue?vue&type=script&lang=js&"
import style0 from "./DebrisGathererEditor.vue?vue&type=style&index=0&id=1cee01b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cee01b6",
  null
  
)

export default component.exports